(function() { window.GUID_f0013666_a14b_4b45_a307_571c04076ee3 = { getGuid: function() { return "f0013666-a14b-4b45-a307-571c04076ee3"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-csr-chart",
                        callback: (accordion, e) => __awaiter(this, void 0, void 0, function* () {
                            var _a, _b, _c, _d;
                            const $statUserGraphsInputs = accordion.$Container.find(`.CSRChartSectionViewModelStatUserGraphs-${accordion.ContentId}`);
                            const $forceAllTimeHiddenInput = accordion.$Container.find(`#CSRateSectionViewModelForceAllTime-${accordion.ContentId}`);
                            const forceAllTime = $forceAllTimeHiddenInput.val() == "True";
                            const $onlyGraphHiddenInput = accordion.$Container.find(`#CSRateSectionViewModelOnlyGraph-${accordion.ContentId}`);
                            const onlyGraph = $onlyGraphHiddenInput.val() == "True";
                            const tooltipUpdatedOnTheMorningOf = (_b = (_a = accordion.$Container
                                .find(`#CSRChartSectionTooltipUpdatedOnTheMorningOf-${accordion.ContentId}`)
                                .val()) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
                            const explanationUpdatedInTheMorning = (_d = (_c = accordion.$Container
                                .find(`#CSRChartSectionExplanationUpdatedInTheMorning-${accordion.ContentId}`)
                                .val()) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "";
                            if ($statUserGraphsInputs.length) {
                                try {
                                    const data = [];
                                    $statUserGraphsInputs.each((index, input) => {
                                        const $input = $(input);
                                        const val = $input.val();
                                        const parsedVal = JSON.parse(val);
                                        const isArray = Array.isArray(parsedVal);
                                        if (isArray) {
                                            data.push(...parsedVal);
                                        }
                                    });
                                    if (data.length) {
                                        const csrChartRootId = `${accordion.ContentId}-chart-root`;
                                        const csrChartContainerHTML = `
                <div id="${csrChartRootId}" class="">
                </div>
                `;
                                        const csrChartControlId = `csrchartsectionviewmodel-${accordion.ContentId}`.toLowerCase();
                                        const $csrChartControlElement = $(`#${csrChartControlId}`);
                                        let csrChart = null;
                                        const csrChartRootIdV2 = `${accordion.ContentId}-chart-root-v2`;
                                        const csrChartContainerHTMLV2 = `
                <div id="${csrChartRootIdV2}" class="">
                </div>
                `;
                                        const csrChartControlIdV2 = `csrchartsectionviewmodel-${accordion.ContentId}-v2`.toLowerCase();
                                        const $csrChartControlElementV2 = $(`#${csrChartControlIdV2}`);
                                        let csrChartV2 = null;
                                        if ($csrChartControlElementV2.length) {
                                            // $csrChartControlElement.append(csrChartContainerHTML);
                                            // csrChart = new CS.Controls.CSRChart(
                                            //   csrChartControlId,
                                            //   csrChartRootId,
                                            //   data,
                                            //   undefined,
                                            //   undefined,
                                            //   undefined,
                                            //   undefined,
                                            //   undefined,
                                            //   forceAllTime,
                                            //   onlyGraph
                                            // );
                                            // await csrChart.init();
                                            $csrChartControlElementV2.append(csrChartContainerHTMLV2);
                                            csrChartV2 = new CS.Controls.CSRChartV2({
                                                controlId: csrChartControlIdV2,
                                                id: csrChartRootIdV2,
                                                statUserGraphs: data,
                                                defaultScope: forceAllTime ? "max" : undefined,
                                                hideEverythingButChart: onlyGraph,
                                                tooltipUpdatedOnTheMorningOfText: tooltipUpdatedOnTheMorningOf,
                                                explanationUpdatedInTheMorningText: explanationUpdatedInTheMorning,
                                            });
                                            yield csrChartV2.initialize();
                                        }
                                        else {
                                            console.error("No chart container found");
                                        }
                                    }
                                }
                                catch (error) {
                                    console.error("Error while parsing stat user graphs", error);
                                }
                            }
                        }),
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section-csr-chart.js.map
